import(/* webpackMode: "eager" */ "/home/www-banklviv/front/src/app/error.tsx");
